import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useParams } from 'react-router'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

import Document from 'js/components/Document'
import { Container } from 'js/components/Grid'
import { H1 } from 'js/components/Heading'
import TabMenu from 'js/components/Navigation/TabMenu'
import TabPanel from 'js/components/Navigation/TabPanel'
import Section from 'js/components/Section/Section'

const ActivityContainer = () => {
    const { t } = useTranslation()
    const { userGuid } = useParams()
    const { pathname } = useLocation()
    const tab = pathname.split('/').pop()

    const { data } = useQuery(USER_ACTIVITY_TOTALS, {
        variables: {
            userGuid,
        },
    })

    const options = [
        {
            to: `../activity/published`,
            label: `${t('global.published')} (${data?.published?.total || 0})`,
            end: true,
            id: 'tab-published',
            ariaControls: 'tabpanel-published',
        },
        {
            to: `../activity/drafts`,
            label: `${t('global.drafts')} (${data?.drafts?.total || 0})`,
            end: true,
            id: 'tab-drafts',
            ariaControls: 'tabpanel-drafts',
        },
        {
            to: `../activity/archived`,
            label: `${t('global.archived')} (${data?.archived?.total || 0})`,
            end: true,
            id: 'tab-archived',
            ariaControls: 'tabpanel-archived',
        },
    ]

    return (
        <>
            <Document title={t('user.activity')} />
            <Section
                backgroundColor="white"
                divider
                style={{ paddingBottom: 0 }}
            >
                <Container size="small">
                    <H1 style={{ marginBottom: '16px' }}>
                        {t('user.activity')}
                    </H1>
                    <TabMenu options={options} />
                </Container>
            </Section>
            <Section>
                <Container size="small">
                    <TabPanel
                        id={`tabpanel-${tab}`}
                        aria-labelledby={`tab-${tab}`}
                        visible
                    >
                        <Outlet />
                    </TabPanel>
                </Container>
            </Section>
        </>
    )
}

export const USER_ACTIVITY_TOTALS = gql`
    query UserActivityTotals($userGuid: String) {
        published: activities(userGuid: $userGuid) {
            total
        }
        drafts: activities(userGuid: $userGuid, statusPublished: [draft]) {
            total
        }
        archived: activities(userGuid: $userGuid, statusPublished: [archived]) {
            total
        }
    }
`

export default ActivityContainer
